import * as React from 'react';
import { useSelector } from 'react-redux';
import { ECurrentErrorField } from '../../../actions/filters/types';
import { trackAreaPick } from '../../../analytics';
import { selectFilters } from '../../../selectors';
import { useActions } from './useActions';
import { EUnits } from '../../../constants/units';
import { intOnly } from '../../../utils/formatters/intOnly';
/** Пропсы для фильтра площади квартиры */

export var useAreaInputProps = function useAreaInputProps() {
  var _useSelector = useSelector(selectFilters),
      area = _useSelector.area,
      errorTooltip = _useSelector.errorTooltip,
      userSetArea = _useSelector.userSetArea;

  var _useActions = useActions(),
      setError = _useActions.setError,
      setUserAreaFlag = _useActions.setUserAreaFlag,
      setArea = _useActions.setArea;
  /** Если есть ошибка, отобразится над инпутом фильтра */


  var errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.area ? errorTooltip.errorText : '';
  /** Обработчик ввода в инпут Площади */

  var onValueChange = React.useCallback(function (value) {
    var intVal = intOnly(value);
    setArea({
      area: Number(intVal)
    });

    if (!userSetArea) {
      setUserAreaFlag({
        userSetArea: true
      });
    }

    if (errorMessage) {
      setError({
        currentErrorField: ECurrentErrorField.area,
        errorText: ''
      });
    }
  }, [errorMessage, userSetArea, setArea, setError, setUserAreaFlag]);
  var shouldShowUnit = Boolean(area);
  return {
    value: area ? String(area) : '',
    unit: EUnits.area,
    errorMessage: errorMessage,
    onValueChange: onValueChange,
    onBlur: trackAreaPick,
    shouldShowUnit: shouldShowUnit
  };
};